import { TBoardId } from '../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { resetMultiselect } from '../../../../../clickManager/effects/resetMultiselect';

export const onDidMount = (
    boardId: TBoardId,
): ThunkAction => {
    return (dispatch: Dispatch) => {
        dispatch(resetMultiselect());
        return Promise.resolve();
    };
};
